import PropTypes from 'prop-types';

const FilterBarItem = ({
  name,
  label,
  type,
  placeholder,
  defaultValue = null,
  options,
  minDate,
  maxDate,
  children,
}) => {
  // This component acts as a declarative config-only component.
  // No need to render anything here.
  return null;
};

FilterBarItem.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'dropdown', 'searchableDropdown', 'dateRange', 'date', 'month', 'toggle', 'multiSelect']).isRequired,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.any,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.array,
      ]).isRequired,
    })
  ),
  enableSelectAll: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
};

export default FilterBarItem;
